<div class="col-12">
    <div class="create">
        <div class="create__body">
            <div class="container">
                <div class="create__container">
                    <div class="row">
                        <div class="col-12">
                            <p class="header-titles">Create your Account</p>
                            <p class="titles">Basic Information</p>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="Saturation"
                                                        label="Saturation"
                                                        placeholder="Saturation"    
                                                        [isRequired]="true"
                                                        [options]="saturationOptions">
                                        </atram-select>
                                    </div>
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                            type="text"
                                            controlName="middleName" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Middle Name *"
                                            [isError]="(!createFormGroup.get('middleName')?.valid && createFormGroup.get('middleName')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                                type="text"
                                                controlName="firstName" 
                                                label=""
                                                [showPhNumber]="false"
                                                placeholder="First Name *"
                                                [isError]="(!createFormGroup.get('firstName')?.valid && createFormGroup.get('firstName')?.touched)"
                                                [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                                type="text"
                                                controlName="lastName" 
                                                label=""
                                                [showPhNumber]="false"
                                                placeholder="Last Name *"
                                                [isError]="(!createFormGroup.get('lastName')?.valid && createFormGroup.get('lastName')?.touched)"
                                                [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="suffix"
                                                        label=""
                                                        placeholder="Suffix"    
                                                        [isRequired]="true"
                                                        [options]="suffixOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-8"></div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="gender"
                                                        label=""
                                                        placeholder="Gender*"    
                                                        [isRequired]="true"
                                                        [options]="genderOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                            type="text"
                                            controlName="pob" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Place of Birth *"
                                            [isError]="(!createFormGroup.get('pob')?.valid && createFormGroup.get('pob')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-datepicker
                                              [parentFormGroup]="createFormGroup"
                                              controlName="dob"
                                              placeholder="Date of Birth *"
                                              label=""
                                              [isRequired]="true"
                                              textColor="black"
                                              componentClass="custom-class"
                                              >
                                        </atram-datepicker>
                                        <!-- (on-search)="handleSearch($event)"
                                              (on-click)="handleClick($event)" -->

                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="citizenship"
                                                        label=""
                                                        placeholder="Citizenship *"    
                                                        [isRequired]="true"
                                                        [options]="citizenshipOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="country"
                                                        label=""
                                                        placeholder="Country *"    
                                                        [isRequired]="true"
                                                        [options]="citizenshipOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-12">&nbsp;</div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="createFormGroup"
                                                        type="text"
                                                        controlName="maritalStatus"
                                                        label=""
                                                        placeholder="Marital Status *"    
                                                        [isRequired]="true"
                                                        [options]="citizenshipOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                            type="text"
                                            controlName="mothersName" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Mother's Maiden Name"
                                            [isError]="(!createFormGroup.get('mothersName')?.valid && createFormGroup.get('mothersName')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="createFormGroup"
                                            type="text"
                                            controlName="spouseName" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Spouse Name"
                                            [isError]="(!createFormGroup.get('spouseName')?.valid && createFormGroup.get('spouseName')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-datepicker
                                              [parentFormGroup]="createFormGroup"
                                              controlName="spouseDoB"
                                              placeholder="Select Date"
                                              label=""
                                              [isRequired]="true"
                                              textColor="black"
                                              componentClass="custom-class"
                                              >
                                        </atram-datepicker>
                                        <!-- (on-search)="handleSearch($event)"
                                              (on-click)="handleClick($event)" -->

                                    </div>
                                </div>
                                <div class="col-2"></div>
                            </div>

                        </div>

                        <div class="col-6">
                            <p class="header-titles">&nbsp;</p>
                            <p class="titles">Present Address</p>
                        </div>
                        <div class="col-6">
                            <p class="header-titles">&nbsp;</p>
                            <div class="address_checkbox">
                                <p class="titles">&nbsp;</p>
                                <atram-checkbox
                                    [parentFormGroup]="addressFormGroup"
                                    controlName="sameAsPermanent"
                                    label="Same as Permanent"
                                    [isRequired]="true"
                                    [isError]="(!addressFormGroup.get('spouseName')?.valid && addressFormGroup.get('spouseName')?.touched)"
                                    [isDisabled]="false"
                                    [componentClass]="'custom-checkbox-class'"
                                ></atram-checkbox>
                                <!-- (onChange)="handleCheckboxChange($event)" -->
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="presentAddress1" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Address 1 *"
                                            [isError]="(!addressFormGroup.get('presentAddress1')?.valid && addressFormGroup.get('presentAddress1')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="presentAddress2" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Address 2 *"
                                            [isError]="(!addressFormGroup.get('presentAddress2')?.valid && addressFormGroup.get('presentAddress2')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="addressFormGroup"
                                                        type="text"
                                                        controlName="presentProvince"
                                                        label=""
                                                        placeholder="Present Province *"    
                                                        [isRequired]="true"
                                                        [options]="suffixOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="addressFormGroup"
                                                        type="text"
                                                        controlName="presentCity"
                                                        label=""
                                                        placeholder="Present City *"    
                                                        [isRequired]="true"
                                                        [options]="suffixOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="presentPostalCode" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Postal Code *"
                                            [isError]="(!addressFormGroup.get('presentPostalCode')?.valid && addressFormGroup.get('presentPostalCode')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-8"></div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="create__items">
                                <p class="titles">Permanent Address</p>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="permanentAddress1" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Address 1 *"
                                            [isError]="(!addressFormGroup.get('permanentAddress1')?.valid && addressFormGroup.get('permanentAddress1')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="permanentAddress2" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Address 2 *"
                                            [isError]="(!addressFormGroup.get('permanentAddress2')?.valid && addressFormGroup.get('permanentAddress2')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="addressFormGroup"
                                                        type="text"
                                                        controlName="permanentProvince"
                                                        label=""
                                                        placeholder="Permanent Province *"    
                                                        [isRequired]="true"
                                                        [options]="suffixOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="create__items">
                                        <atram-select [parentFormGroup]="addressFormGroup"
                                                        type="text"
                                                        controlName="permanentCity"
                                                        label=""
                                                        placeholder="Permanent City *"    
                                                        [isRequired]="true"
                                                        [options]="suffixOptions">
                                        </atram-select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="addressFormGroup"
                                            type="text"
                                            controlName="permanentPostalCode" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Postal Code *"
                                            [isError]="(!addressFormGroup.get('permanentPostalCode')?.valid && addressFormGroup.get('permanentPostalCode')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-8"></div>
                            </div>
                        </div>

                        <div class="col-12">
                            <p class="header-titles">&nbsp;</p>
                            <p class="titles">Contact Information</p>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="contactFormGroup"
                                            type="text"
                                            controlName="residentialContactNumber" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Residential Contact Number"
                                            [isError]="(!contactFormGroup.get('residentialContactNumber')?.valid && contactFormGroup.get('residentialContactNumber')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="contactFormGroup"
                                            type="text"
                                            controlName="mobileNumber" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Mobile Number *"
                                            [isError]="(!contactFormGroup.get('mobileNumber')?.valid && contactFormGroup.get('mobileNumber')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="create__items">
                                        <atram-textbox [parentFormGroup]="contactFormGroup"
                                            type="text"
                                            controlName="emailAddress" 
                                            label=""
                                            [showPhNumber]="false"
                                            placeholder="Email Address *"
                                            [isError]="(!contactFormGroup.get('emailAddress')?.valid && contactFormGroup.get('emailAddress')?.touched)"
                                            [isRequired]="true">
                                        </atram-textbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <p class="header-titles">&nbsp;</p>
                            <p class="titles">Identification</p>
                        </div>
                        <div class="card">
                            <div class="f-form_input">
                                <input style="display:none;" #uploader multiple type="file"  />
                                <!-- [accept]="'.' + attachmentFileTypeSupported.join(',.')" (change)="fileAttach($event)" -->
                                <div class="col-12" style="padding-top:30px">
                                    <atram-button label="Choose Files"
                                                    componentClass="btn-submit"
                                                    (on-click)="uploader.click()">
                                    </atram-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>